import * as React from 'react';
import { ControlFacet } from '../models/controls/ControlFacet';

export interface IUserHoverCardProp {
  personKey: string;
  displayValue?: string;
}

export const userHoverCardControl: ControlFacet<{
  personKey: string;
  displayValue?: string;
}, {
    userHoverCard: React.ComponentType<IUserHoverCardProp>;
  }> = new ControlFacet('userHoverCardControl');